import {React,useState,useEffect} from 'react'
import './pages.css'
import 'bootstrap/dist/css/bootstrap.min.css';
import Form from 'react-bootstrap/Form';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import { Button,Modal,ModalHeader } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import {ToastContainer,toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Axios from 'axios';
import Marquee from "react-fast-marquee";


export default function Login() {

    const [email, setEmail] = useState("");
    const [password, setPassword] = useState('')
    const navigate = useNavigate();
    const [loginText, setLogintext] = useState('LOGIN')
    const [loading, setLoading] = useState(true)
    const [modal, setModal] = useState('');
    const [sendOTP, setSendotp] = useState(1);
    const [sendText, setSendtext] = useState('SEND OTP');
    const [code, setCode] = useState('');
    const [otp, setOtp] = useState('');
    const [newPassword, setNewpassword] = useState('');
    const [account, setAccount] = useState('');
    const [mail, setMail] = useState('')
    const [ConfirmNewpassword, setConfirmnewpassword] = useState('')
    const [submitText, setSubmittext] = useState('Reset Password')


    const toRegister=()=>{
        
        navigate('/register')
    }
    const toHome=()=>{
        navigate('/dashboard')
    }

    useEffect(() => {
        const user = localStorage.getItem('email'); // Retrieve email
        if (user) {
            
          toHome()
        } else {
       
        }
      }, []);

    const login=async()=>{
        if(email && password){
            setLogintext('Please wait...')
            const ress = await fetch(`https://panel.yunshuglobal.com:3063/api/checkEmail?email=${email}`);
            const dataa = await ress.json();
            const {success} = dataa;

            if(success){
                
                const res = await fetch('https://panel.yunshuglobal.com:3063/api/login',{
                    method:"POST",
                    headers:{
                        "Content-Type":"application/json"
                    },
                    body:JSON.stringify({email,password}),
                    credentials:"include"
                })
    
                const data = await res.json();
                const {success} = data;
                if(success==true){
                    localStorage.setItem('email', email);
                    setLogintext('LOGIN')
                    toHome();
                }
                else{
                    setLogintext('LOGIN')
                    toast.error('Incorrect email/password combination')
                }

            }
            else{
                setLogintext('LOGIN')
                toast.error('Email does not exist')
            }


           
        }
    }

    const toggle =()=>{
        setModal(!modal)
    }

    const triggerOTP=async()=>{
        if(account){

            const ress = await fetch(`https://panel.yunshuglobal.com:3063/api/checkEmail?email=${account}`);
            const dataa = await ress.json();
            const {success} = dataa;

            if(success){
                setSendtext('Please wait...');
            const randomCode = Math.floor(100000 + Math.random() * 900000); // generates a number between 100000 and 999999
            setCode(randomCode);

            const res = await Axios.post('https://n8n.yunshuafrica.com/webhook/33c92827-8903-4b08-a31f-e27765d9a95e',{account,randomCode})
            setSendotp(2);
            setSendtext('SEND OTP')

            }
            else{
                toast.error('Email does not exist')
            }

            
        }

    }

    const validate=()=>{
        if(otp == code){
            
            setSendotp(3)
        }
        else{
            toast.error('Incorrect code')
        }
    }

    const resetPassword=async()=>{
        setSubmittext('Please wait...')
        const res = await fetch('https://panel.yunshuglobal.com:3063/api/resetPassword',{
            method:"POST",
            headers:{
                "Content-Type":"application/json"
            },
            body:JSON.stringify({account,newPassword}),
            credentials:"include"
        })

        const data = await res.json();
        const {success} = data;
        if(success){
            setSubmittext('Reset Password')
            setAccount('');
            setOtp('')
            setCode('')
            setSendotp(1)
            setEmail('')
            setPassword('')
            setModal(false)

        }
        else{
            setSubmittext('Reset Password')
            toast.error('Something went wrong')
        }

    }


  return (
    <div className='loginContainer'>
        <ToastContainer />
        <div className="loginMain">
            <div className="marquee">
            <Marquee>
                <h3>NOTICE: DEADLINE FOR REGISTRATION IS 8TH APRIL 2026</h3>
            </Marquee>

            </div>
            <div className="loginWrapper">
                <h2 className='loginTitle'>Motor Claims Database</h2>
                <p className='slogan'>A Motor Claims Database For Court Action & Motor Insurance Reforms</p>
                <p className='loginText'>LOGIN TO PROCEED TO DASHBOARD</p>
                <FloatingLabel className='formInput' controlId="floatingInputGrid" label="Email" onChange={(e)=>{setEmail(e.target.value)}}>
                    <Form.Control  className='inputSearch' value={email}  type="email" placeholder="email@example.com" />
                </FloatingLabel>
                <FloatingLabel className='formInput' controlId="floatingInputGrid" label="Password" onChange={(e)=>{setPassword(e.target.value)}}>
                    <Form.Control  className='inputSearch' value={password}  type="password" placeholder="Secure password" />
                </FloatingLabel>

                <Button color='info' className='loginButton' onClick={login}>{loginText}</Button>

                <p className='forgot' onClick={toggle}>Forgot password?</p>
                <h1 className='pop' >ARE YOU NEW HERE?</h1>
                <button onClick={toRegister} className='signupButton'>SIGN UP NOW</button>

            </div>
            
        </div>
        {/* <div className="loginSide">
            <div className="sideContainer">
        
                
                <div className="mpesaDetails">
                <img src="/mpesa.webp" alt=""  className='mpesaLogo'/>
                <p >PAYBILL: 247 247</p>
                <p>Account No: 667899</p>
                <hr />
                <p>Individual Owner: Kes. 10,000 /=</p>
                <p>Saccos/Companies: Kes. 20,000 /=</p>


                </div>
                <img src="/claimbanner1.jpg" alt="" className='banner1' />
               
                
               
            </div>

        </div> */}

        <Modal isOpen={modal} toggle={toggle}>
            <ModalHeader>Reset password</ModalHeader>
            <div className="modalContainer">
                {sendOTP ==1 &&
                <>
                    <FloatingLabel className='formInput' controlId="floatingInputGrid" label="Email" onChange={(e)=>{setAccount(e.target.value)}}>
                        <Form.Control  className='inputSearch' value={account}  type="email" placeholder="email@example.com" />
                    </FloatingLabel>
                    <Button color='success' onClick={triggerOTP}>{sendText}</Button>
                    
                </>
                
                }
                {sendOTP ==2 &&
                <>
                    <FloatingLabel className='formInput' controlId="floatingInputGrid" label="Enter OTP Sent" onChange={(e)=>{setOtp(e.target.value)}}>
                        <Form.Control  className='inputSearch' value={otp}  type="text" placeholder="Enter OTP Sent" />
                    </FloatingLabel>
                    <Button color='success' onClick={validate}>Validate</Button>
                    <Button style={{marginLeft:'3%'}} color='danger' onClick={()=>{setSendotp(1)}}>Resend OTP</Button>
                    
                </>
                
                }
                {sendOTP == 3 &&
                <>
                    <FloatingLabel className='formInput' controlId="floatingInputGrid" label="New password" onChange={(e)=>{setNewpassword(e.target.value)}}>
                        <Form.Control  className='inputSearch' value={newPassword}  type="password" placeholder="New password" />
                    </FloatingLabel>
                    <FloatingLabel className='formInput' controlId="floatingInputGrid" label="Confirm New password" onChange={(e)=>{setConfirmnewpassword(e.target.value)}}>
                        <Form.Control  className='inputSearch' value={ConfirmNewpassword}  type="password" placeholder="Confirm New password" />
                    </FloatingLabel>
                    <Button color='success' onClick={resetPassword}>{submitText}</Button>

                </>
                
                }
                

            </div>
        </Modal>
    </div>
  )
}
